"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.llmGeneralStepAudio = void 0;
const csrf_1 = require("@app/utils/csrf");
function llmGeneralStepAudio(apiBase, body) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function* () {
        const base = (apiBase || "").replace(/\/+$/, "");
        const res = yield fetch(`${base}/llm_general_step`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-CSRFToken": (0, csrf_1.getCsrfToken)(),
                "Referer": base + "/",
            },
            credentials: "include",
            body: JSON.stringify(body),
        });
        const coverage = parseFloat((_a = res.headers.get("X-Coverage")) !== null && _a !== void 0 ? _a : "0");
        const raw = (_b = res.headers.get("X-Comment")) !== null && _b !== void 0 ? _b : "";
        const comment = new TextDecoder().decode(Uint8Array.from(atob(raw), c => c.charCodeAt(0)));
        const ct = res.headers.get("Content-Type") || "";
        const blob = ct.includes("audio/") ? yield res.blob() : null;
        console.log("coverage ", coverage);
        console.log("comment ", comment);
        return { coverage, comment, blob };
    });
}
exports.llmGeneralStepAudio = llmGeneralStepAudio;
